import {
  createNestablePublicClientApplication,
  type IPublicClientApplication,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";

export interface PublicConfig {
  clientId: string;
  tenantId: string;
  apiScope: string;
  devAuthBypass: boolean;
}

let pca: IPublicClientApplication | null = null;
let scopes: string[] = [];

/**
 * Nested App Authentication: inside Teams the token comes from the host itself, with no
 * login screen (the Entra page does not open in an iframe). Outside Teams it falls back to the popup flow.
 */
export async function initAuth(config: PublicConfig): Promise<void> {
  if (config.devAuthBypass) return;
  scopes = [config.apiScope];
  pca = await createNestablePublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: `https://login.microsoftonline.com/${config.tenantId}`,
      redirectUri: window.location.origin,
    },
  });
}

export async function getAccessToken(): Promise<string | null> {
  if (!pca) return null;
  const account = pca.getActiveAccount() ?? pca.getAllAccounts()[0];
  try {
    const result = await pca.acquireTokenSilent({ scopes, ...(account ? { account } : {}) });
    pca.setActiveAccount(result.account);
    return result.accessToken;
  } catch (err) {
    if (!(err instanceof InteractionRequiredAuthError) && account) throw err;
    const result = await pca.acquireTokenPopup({ scopes });
    pca.setActiveAccount(result.account);
    return result.accessToken;
  }
}
